import React, { useContext, useEffect, useState } from 'react'
import { NormasContext } from '../../context/NormasContext'
import "./Subtareas.scss"
import { Accordion } from "react-bootstrap"
import Muestras from './Muestras'
import { Oval } from 'react-loader-spinner'

const Subtareas = ({ idTarea }) => {
    const [activeSubtaskKey, setActiveSubtaskKey] = useState(null);

    const { 
        status,
        subtareas,
        fetchSubtareas
    } = useContext(NormasContext)

    useEffect(() => {
        // Convertimos idTarea a string para la búsqueda, ya que activeTaskKey es string
        const idTareaString = idTarea.toString();
        // Solo cargamos si idTarea existe Y NO ESTÁ YA EN CACHÉ (subtareas[idTareaString] === undefined)
        if (idTarea && subtareas[idTareaString] === undefined) {
            fetchSubtareas({
                idtarea: idTarea
            })
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idTarea])

    const handleSubtaskSelect = (eventKey) => {
        setActiveSubtaskKey(activeSubtaskKey === eventKey ? null : eventKey);
    };

    const data = subtareas[idTarea] || []

    const padres = data.filter(p => p.nivel_prioridad === 0)
    const getHijas = (idPadre) => data.filter(p => p.fk_subtarea_padre === idPadre)

    return (
        <div className='subtareas'>
            {status.subtareas.loading ? (
                <div className='loading__subtareas d-flex flex-row align-items-center justify-content-center'>
                    <Oval
                        visible={true}
                        height="40"
                        width="40"
                        color="#0d6efd"
                        ariaLabel="oval-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                    />
                    <p className='m-0 fw-medium'>Loading...</p>
                </div>
            ) : (
                <>
                    {status.subtareas.error ? (
                        <div className='subtareas--error d-flex flex-column align-items-center'>
                            <p className='text-danger fw-medium'><i className="bi bi-exclamation-circle me-1"></i> {status.subtareas.error}</p>
                        </div>
                    ) : (
                        <>
                            {padres.length > 0 && (
                                <div className='subtareas__container'>
                                    {padres.map((padre) => {
                                        const hijas = getHijas(padre.id_subtarea_norma)
                                        const eventKeyString = padre.id_subtarea_norma.toString();

                                        if(hijas.length > 0){
                                            return (
                                                <Accordion 
                                                    key={padre.id_subtarea_norma} 
                                                    className='mb-3'
                                                    activeKey={activeSubtaskKey}
                                                    onSelect={handleSubtaskSelect}
                                                >
                                                    <Accordion.Item 
                                                        eventKey={eventKeyString}
                                                    >
                                                        <Accordion.Header>{padre.titulo}</Accordion.Header>
                                                        <Accordion.Body>
                                                            {padre.descripcion && (
                                                                <div className='texto-descripcion'>
                                                                    <p>{padre.descripcion}</p>
                                                                </div>
                                                            )}
                                                            <div>
                                                                {hijas.map((hija) => (
                                                                    <div 
                                                                        key={hija.id_subtarea_norma} 
                                                                        className='subtareas__container__eachSub hijas p-3 rounded-3 border border-light-subtle'
                                                                    >
                                                                        <p className='fw-semibold'>{hija.titulo}</p>
                                                                        {hija.descripcion && (
                                                                            <div className='texto-descripcion'>
                                                                                <p>{hija.descripcion}</p>
                                                                            </div>
                                                                        )}
                                                                        <Muestras idSubtarea={hija.id_subtarea_norma} tieneMuestras={hija.tiene_muestras} />
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion>
                                            )
                                        }

                                        return (
                                            <div key={padre.id_subtarea_norma} className="subtareas__container__eachSub padres p-3 rounded-3 border border-light-subtle">
                                                <p className='fw-semibold'>{padre.titulo}</p>
                                                {padre.descripcion && (
                                                    <div className='texto-descripcion'>
                                                        <p>{padre.descripcion}</p>
                                                    </div>
                                                )}
                                                <Muestras idSubtarea={padre.id_subtarea_norma} tieneMuestras={padre.tiene_muestras} />
                                            </div>
                                        )
                                    })}
                                </div>
                            )}
                        </>
                    )}
                </>
            )}
        </div>
    )
}

export default Subtareas